// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__NZl58","text":"Badge_text__bR31l"};